<template>
    <!-- 首页banner 组件 -->
    <div :class="['banner-container', content.classname]">
      <div class="banner-box" :class="[{'rowReverse': content.rowReverse}]">
        <div class="banner-left">
          <h1 class="title">{{ content.title }}</h1>
          <p class="des"><span v-if="content.desStrong">{{ content.desStrong }}</span> {{ content.des }}</p>
          <a :href="content.link"> 
            <div class="btn">{{ content.btnText }}</div>
          </a>
        </div>
        <div class="banner-right">
          <img :src="$getFile(content.img)" v-if="content.img" alt="">
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Koutu_Banner',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => { }
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .banner-container {
    background: #252325;
    &.CleverCutsAI {
      background: url("@/assets/images/koutu/Banner/bg.jpg") no-repeat top center;
      background-size: cover;
    }
    &.EZCut {
      background: white;
    }
    &.QuickChop{
      background: #0055FF;
    }
    &.SliceEase{
      background: linear-gradient(315deg, #FD2C52 0%, #EF4B68 100%);
    }
    &.PixelPeeler{
      background: url("@/assets/images/koutu/Banner/PixelPeeler/bg.jpg") no-repeat top center;
      background-size: cover;
    }
    &.PureCut{
      background: #463699;
    }
    &.RemoveEase{
      background: #FFF0EC;
    }
    &.EraseItFast{
      background: #034CF3;
    }
    &.SelectSlice{
      background: linear-gradient(128deg, #BFF2FB 0%, #FFF8C1 30%, #BFF2FB 100%);
    }
    &.QuickCutPro{
      background: url("@/assets/images/koutu/Banner/QuickCutPro/bg.jpg") no-repeat top center;
      background-size: cover;
    }
    &.OneClickCrop {
      background: linear-gradient(315deg, #FD2C52 0%, #EF4B68 100%);
    }
    &.PicSnatch {
      background: url("@/assets/images/koutu/Banner/PicSnatch/bg.jpg") no-repeat top center;
      background-size: cover;
    }
    &.RemovifyPro {
      background: #4C3626;
    }
    &.InstaMask{
      background: #4C3626;
    }
    
}
@media #{'only screen and (min-width: 992px)'} {
    .banner-container {
      overflow: hidden;
      font-family: Arial, Arial;
      width: 100%;
      padding: 50px 0;
      .banner-box {
        display: flex;
        align-items: center;
        justify-content: center;
        &.rowReverse{
          flex-direction: row-reverse;
        }
        gap: 20px;
        max-width: 1080px;
        margin: 0 auto;
        padding: 22px 20px 24px;
  
        .banner-left {
          width: 627px;
          height: auto;
          cursor: default;
  
          .title {
            margin-bottom: 40px;
            font-size: 65px;
            font-weight: 900;
            line-height: 1.1;
            color: var(--theme-koutu-banner-color);
          }
          .des {
            font-size: 24px;
            font-weight: bold;
            color: var(--theme-koutu-banner-color);
            span {
                color: #FE9227;
            }
          }
          .btn {
            width: 200px;
            padding: 15px 0;
            text-align: center;
            color: var(--theme-koutu-banner-btn);
            font-size: 20px;
            font-weight: bold;
            margin-top: 40px;
            background: var(--theme-koutu-banner-btn-bg);
            box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
            border-radius: 30px;
            cursor: pointer;
          }
        }
  
        .banner-right {
          width: 464px;
          margin-right: 10px;
  
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
  
  @media #{'only screen and (max-width: 991px)'} {
    .banner-container {
      font-family: Arial, Arial;
      width: 100%;
      .banner-box {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column-reverse;
        padding: .5rem 0 1rem;
        .banner-left {
          padding: 0 .5rem;
          margin: 0 auto;
          text-align: center;
  
          .title {
            margin: 0 0 .2rem;
            padding: 0 .2rem;
            font-size: 0.56rem;
            color: var(--theme-koutu-banner-color);
            line-height: .72rem;
          }
  
          .des {
            margin: .4rem auto;
            font-size: .32rem;
            font-weight: bold;
            color: var(--theme-koutu-banner-color);
            span {
                color: #FE9227;
            }
          }
          .btn {
            width: 200px;
            padding: 15px 0;
            text-align: center;
            color: var(--theme-koutu-banner-btn);
            font-size: 20px;
            font-weight: bold;
            margin-top: 40px;
            background: var(--theme-koutu-banner-btn-bg);
            box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
            border-radius: 30px;
            margin: .5rem auto 0;
            cursor: pointer;
          }

        }
  
        .banner-right {
          width: 100%;
          margin: 0 auto;
  
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
  </style>